module.exports = __webpack_public_path__ + "static/media/slide0.03d9d753.gif";